/** Usata con `MuiButton` nel tema: padding verticale 0, allineamento barre Period/Compare. */
export const KIPIFY_FILTER_APPLY_BUTTON_CLASS = 'KipifyFilterApply';
